import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { backUrl } from "../config";

const redPath = "contragentApi";
const tagApi = "contragents";


export const contragentApi = createApi({
  reducerPath: redPath,
  baseQuery: fetchBaseQuery({
    baseUrl: backUrl,
    tagTypes: [tagApi],
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getContragents: build.query({
      query: (param) => `${tagApi}${param ? param : ""}`,
      providesTags: [tagApi],
    }),
    createContragent: build.mutation({
      query: (newContragent) => ({
        url: `${tagApi}`,
        method: "POST",
        body: {
          data: {
            ...newContragent
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
    updateContragent: build.mutation({
      query: (newData) => ({
        url: `${tagApi}/${newData.id}`,
        method: "PUT",
        body: {
          data: {
            ...newData.updated,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
  }),
});

export const {
  useGetContragentsQuery,
  useUpdateContragentMutation,
  useCreateContragentMutation,
} = contragentApi;
